'use client';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { initCustomerStore, useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import Link from '@eliadmin/core/src/components/link';
import { Popover, PopoverContent, PopoverTrigger } from '@eliadmin/core/src/components/ui/popover';
import { HiChevronDown } from 'react-icons/hi';
import { FiChevronDown, FiUser } from 'react-icons/fi';
import { useRouter } from 'next/navigation';
import { MdOutlineLogout } from 'react-icons/md';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useSystemLabels } from '@eliadmin/core/src/hooks/use-system-labels';
import { Separator } from '@eliadmin/core/src/components/ui/separator';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { Spinner } from '@eliadmin/core/src/components/ui/spinner';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

export const HeaderButtons = () => {
  const { t } = useTranslations();
  const systemLabels = useSystemLabels();
  const { me, isInitialized } = useCustomerStore();
  const customerType = me?.customer?.customer_type.type;
  const router = useRouter();
  const { isOpen, setIsOpen } = useDisclosure();

  const handleClickProfile = () => {
    setIsOpen(false);
    router.push(ROUTES.PROFILE());
  };

  const handleSignOut = () => {
    initCustomerStore(null);
    setIsOpen(false);
    router.push(ROUTES.SIGN_OUT());
    router.push(ROUTES.HOME());
  };

  const ProfilePopover = () => (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button aria-label={systemLabels('profile')} className="flex items-center gap-2">
          <FiChevronDown className="h-5 w-5" />
          <FiUser className="h-5 w-5" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-48">
        <div className="flex flex-col gap-2">
          <div
            onClick={() => handleClickProfile()}
            className="flex cursor-pointer  items-center gap-2 px-1 py-2 text-primary"
          >
            <FiUser className={cn('h-5 w-5', '')} />
            <p className={cn('text-sm font-semibold md:text-base', 'text-primary')}>
              {t('Profil')}
            </p>
          </div>
          <Separator />
          <div
            className="flex cursor-pointer items-center gap-2 px-1 py-2 text-destructive-foreground"
            onClick={() => handleSignOut()}
          >
            <MdOutlineLogout className={cn('h-5 w-5', '')} />
            <p className={cn('text-sm font-semibold md:text-base', '')}>{t('text258')}</p>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );

  if (!isInitialized) {
    return (
      <Button disabled aria-label={systemLabels('profile')} aria-busy="true" variant={'accent'} className="w-32">
        <Spinner className="h-5 w-5" />
      </Button>
    );
  }

  if (!me) {
    return (
      <Button asChild variant={'accent'}>
        <Link prefetch={false} href={'/prihlasit-sa'}>
          {t('text190')}
        </Link>
      </Button>
    );
  }

  if (customerType === 'user' || customerType === 'student') {
    return (
      <div className="flex gap-2">
        <Button variant={'accent'} asChild>
          <Link className="whitespace-nowrap" prefetch={false} href={ROUTES.CURRICULUM_CREATE()}>
            {t('text2251')}
          </Link>
        </Button>
        <ProfilePopover />
      </div>
    );
  }

  if (customerType === 'company') {
    return (
      <div className="flex gap-2">
        <Button variant={'accent'} asChild>
          <Link prefetch={false} className="text-center" href={'/pridat-ponuku'}>
            Pridať pracovnú ponuku
          </Link>
        </Button>
        <ProfilePopover />
      </div>
    );
  }

  if (customerType === 'school') {
    return (
      <div className="flex gap-2">
        <Button variant={'accent'} asChild>
          <Link prefetch={false} className="text-center" href={'/vytvorit-kurz'}>
            Pridať vzdelávací kurz
          </Link>
        </Button>
        <ProfilePopover />
      </div>
    );
  }

  return <div>Error</div>;
};
